<template>
  <SvoiCheckbox v-bind="$attrs"><slot /></SvoiCheckbox>
</template>

<script lang="ts" setup>
import { SvoiCheckbox } from '@svoi-ui/components/checkbox'
</script>
